import { render, staticRenderFns } from "./ProfileData.vue?vue&type=template&id=953c8aea&scoped=true"
import script from "./ProfileData.vue?vue&type=script&lang=js"
export * from "./ProfileData.vue?vue&type=script&lang=js"
import style0 from "./ProfileData.vue?vue&type=style&index=0&id=953c8aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953c8aea",
  null
  
)

export default component.exports